// var myElement = document.getElementById("dummy-chat-button");
// myElement.style.width = "40px";
// myElement.style.height = "40px";

jQuery(document).ready(function () {
  // start moi code: for size guide code only

  // var _metaimg = $("meta[property='og:image:secure_url']").attr("content");
  // $("#size-popup3 .model-wrapper .bag-model").attr("src", _metaimg);

  // end moi code

  setTimeout(() => {
    var chatIframe = $("#dummy-chat-button-iframe");
    var chatButton = chatIframe.contents().find(".mobile-only");

    if (chatButton) {
      chatButton.css("height", "30px");
      chatButton.css("width", "30px");
    }

    $('button.gravity-button').css('border-radius', 0);
  }, 1500);
  
});

jQuery(document).ready(function () {
  $(".size-chart-slider").owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    items: 1,
    dots: true,
  });

  // $(".no-round-border .shopify-payment-button #buttons-container .paypal-button").removeClass("paypal-button-border-radius");
  // $(".paypal-button.paypal-button-border-radiusn").css("border-radius", "0 !important");

  $("#sizeOpen").click(function () {
    $("#size-popup").fadeIn();

    var dataSize = parseInt($("#size-popup").data("attr"));
    console.log(dataSize, "size");

    if (dataSize <= 24) {
      $(".size-chart-slider").trigger("to.owl.carousel", 0);
      console.log("micro");
    } else if (dataSize >= 25 && dataSize <= 29) {
      $(".size-chart-slider").trigger("to.owl.carousel", 1);
      console.log("mini");
    } else {
      $(".size-chart-slider").trigger("to.owl.carousel", 2);
      console.log("medium");
    }
  });


  $('div[x-ref="video_container"] > button').on('click', function () {
      setTimeout(function() {
        $('body.template-product ul.splide__list li video').attr('oncanplay', 'this.muted=true');
      },10);
  });

  // moi code: swipe for splide
  var startX, startY, distX, distY, swipeThreshold = 30;
  $('.splide').on('touchstart', function(e) {
    var touchStart = e.originalEvent.touches[0];
    startX = touchStart.pageX;
    startY = touchStart.pageY;
  });

  $('.splide').on('touchmove', function(e) {
    distX = e.originalEvent.touches[0].pageX - startX;
    distY = e.originalEvent.touches[0].pageY - startY;

    if (Math.abs(distX) > Math.abs(distY)) {
      e.preventDefault();
    }
  });

  $('.splide').on('touchend', function(e) {
    var touchEnd = e.originalEvent.changedTouches[0];
    distX = touchEnd.pageX - startX;
    distY = touchEnd.pageY - startY;

    if (Math.abs(distX) < swipeThreshold && Math.abs(distY) < swipeThreshold) {
      return;
    }

    if (Math.abs(distX) > Math.abs(distY)) {
      if (distX > 0) {
        // Swipe Right
        $('button.splide__arrow--prev').trigger('click');
      } else {
        // Swipe Left
        $('button.splide__arrow--next').trigger('click');
      }
    }
  });
  // moi end code: swipe for splide
});


// document.addEventListener("DOMContentLoaded", function () {
//   const splide = new Splide(".splide", {
//     type: 'fade',
//     drag: true,
//     swipe: true,
//   }).mount();
// });


// var spanElement = document.createElement('span');
// spanElement.id = 'sizeOpen';
// spanElement.setAttribute('data-attr', '{{ product.metafields.custom.size | round }}');
// spanElement.textContent = 'Size Guide';

// var parentElement = document.getElementById('product-description');
// var fourthPElement = parentElement.getElementsByTagName('p')[3];
// fourthPElement.parentNode.insertBefore(spanElement, fourthPElement.nextSibling);

// size chart
jQuery(document).ready(function () {
  jQuery("#sizeOpen").click(function () {
    jQuery("#size-popup").fadeIn();
  });

  jQuery("#closePop").click(function () {
    jQuery("#size-popup").fadeOut();
  });
});

//
// var _size = 0;
// $("#sizeOpen").click(function () {
//   $("#size-popup").fadeIn();
//   _size = parseInt($(this).data("attr"));
//   console.log(_size, 'size');
// });

$(document).ready(function () {
  var initialSize = parseInt($("#size-popup2").data("attr"));

  $(".range-item > p.bagsize-label span").text(initialSize);

  $(".range-item .bagsize-slider")
    .val(initialSize)
    .attr("max", 30)
    .attr("min", 20)
    .attr("value", initialSize)
    .attr("step", 5);

  setBagImageTransformation(initialSize);

  $("#sizeOpen2").click(function () {
    $("#size-popup2").fadeIn();
    $("body").addClass("no-scroll");
    _size = initialSize;
    $(".range-item > p.bagsize-label span").text(initialSize);
    $(".range-item .bagsize-slider")
      .val(initialSize)
      .attr("max", 30)
      .attr("min", 20)
      .attr("value", initialSize)
      .attr("step", 5);
  });

  var slider_oldVal = 0,
    ctr = 1,
    new_h = 1;

  $(".range-item .bagsize-slider").on("input", function (e) {
    var current_size = $(this).val();
    $(".range-item > p.bagsize-label span").text(current_size);
    setBagImageTransformation(current_size);

    slider_oldVal = current_size;
  });

  function setBagImageTransformation(size) {
    if (size == 20) {
      new_h = 0.9;
    } else if (size == 25) {
      new_h = 1.04;
    } else if (size == 30) {
      new_h = 1.11;
    }
    // if (size == 20) {
    //   new_h = 1.00;
    // } else if (size == 25) {
    //   new_h = 1.04;
    // } else if (size == 30) {
    //   new_h = 1.09;
    // }

    $(".model-wrapper #bag-image").css(
      "transform",
      "scale(" + new_h.toFixed(2) + ")"
    );
    console.log(new_h.toFixed(2), "=>", size);
  }
});

$("#sizeOpen3").click(function () {
  $("#size-popup3").fadeIn();
  $("body").addClass("no-scroll");
});
$("#closePop3").click(function () {
  $("#size-popup3").fadeOut();
  $("body").removeClass("no-scroll");
});

var _size = 0;
$("#sizeOpen2").click(function () {
  $("#size-popup2").fadeIn();
  $("body").addClass("no-scroll");
  _size = parseInt($("#sizeOpen2 #size-popup2").data("attr"));
  $(".range-item > p.bagsize-label span").text(
    $("#sizeOpen2 #size-popup2").data("attr")
  );
  $(".range-item .bagsize-slider")
    .val(parseInt($("#sizeOpen2 #size-popup2").data("attr")))
    .attr("max", 30)
    .attr("min", 20)
    .attr("value", parseInt($("#sizeOpen2 #size-popup2").data("attr")))
    .attr("step", 5);
});

//   var slider_oldVal = 0,
//     ctr = 1,
//     new_h = 1;

//   $(".range-item .bagsize-slider").on("input", function (e) {
//     var current_size = $(this).val();
//     $(".range-item > p.bagsize-label span").text(current_size);

//     if (current_size == 20) {
//       new_h = 1.00;
//     } else if (current_size == 25) {
//       new_h = 1.04;
//     } else if (current_size == 30) {
//       new_h = 1.09;
//     }

//   $(".model-wrapper #bag-image").css(
//     "transform",
//     "scale(" + new_h.toFixed(2) + ")"
//   );
//   console.log(new_h.toFixed(2), '=>', current_size);
//   slider_oldVal = current_size;
// });

// model size
var slider_oldVal_model = 0,
  ctr_model = 1,
  new_h_model = 1;
$(".range-item .modelsize-slider").on("input", function (e) {
  var current_size = $(this).val();
  var _s = parseFloat(current_size) + 4 + "”";
  var final_s = _s.replace(".", "’");
  $(".range-item > p.heightmodel").text(final_s);

  // if (final_s.includes("’")) {
  //   var feetAndInches = final_s.split("’");
  //   var feet = parseFloat(feetAndInches[0]);
  //   var inches = parseFloat(feetAndInches[1]);
  //   var totalInches = feet * 12 + inches;
  // } else {
  //     var inches = parseFloat(final_s);
  //     if (isNaN(inches)) {
  //         inches = 0;
  //     }
  //     var feet = 0;
  //     var totalInches = inches;
  // }
  // var centimeters = totalInches * 2.54;
  // centimeters = centimeters.toFixed(2);
  // $(".range-item > p.heightmodel").text(centimeters);

  if (slider_oldVal_model > current_size) {
    ctr_model = ctr_model - 0.01 ?? 1;
  } else {
    ctr_model = ctr_model + 0.01 ?? 1;
  }
  new_h_model = ctr_model;

  console.log(current_size);
  console.log(new_h_model);

  $(".model-wrapper #model-image").css(
    "transform",
    "scale(" + new_h_model.toFixed(2) + ")"
  );
  slider_oldVal_model = current_size;
});

$("#closePop2").click(function () {
  $("#size-popup2").fadeOut();
  $("body").removeClass("no-scroll");
});

document.getElementById("pop-cart").addEventListener("click", function() {
    document.getElementById("addToCartButton").click();
});
document.getElementById("pop-cart2").addEventListener("click", function() {
    document.getElementsByClassName("studio-seizh-restock-button")[0].click();
});